import { Component, Inject, Optional } from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SafeHtmlPipe } from '@ms/core/pipes/sanitize-html.pipe';
import { FlexModule } from '@ngbracket/ngx-layout';
import { HotToastRef } from '@ngxpert/public-api';

export interface ToasterMessage {
    message?: string;
    detail?: string;
    title?: string;
    type?: 'error' | 'warning' | 'info' | 'success';
}

@Component({
    selector: 'ms-toaster-message',
    templateUrl: 'toaster-message.component.html',
    imports: [MatExpansionModule, FlexModule, FontAwesomeModule, SafeHtmlPipe],
    styles: [
        `
            :host ::ng-deep .mat-expansion-panel-body {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }
            :host ::ng-deep .mat-expansion-panel-header:hover {
                background: white !important;
            }
            :host ::ng-deep .mat-expansion-panel-header {
                padding: 0px 16px 0px 0px !important;
                align-items: start !important;
                height: 100% !important;
            }
            :host ::ng-deep .mat-expansion-panel-header-description {
                color: black !important;
                max-width: 450px;
            }
            :host ::ng-deep .mat-expansion-panel-content {
                background: rgb(242, 242, 242);
                border-radius: 4px;
                padding-left: 8px;
                padding-right: 8px;
            }
        `,
    ],
})
export class ToasterMessageComponent {
    constructor(@Optional() @Inject(HotToastRef) public toastRef: HotToastRef<ToasterMessage>) {
        console.log('TOASTER-DATA', this.toastRef.data);
    }
}
